import React, { useState, useEffect } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

const AccountManagement = () => {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();
  const [showProductsDropdown, setShowProductsDropdown] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }
  }, [user, navigate]);

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleProductSelect = (product) => {
    setShowProductsDropdown(false);
    // No products available
  };

  const handleLogout = async () => {
    try {
      await signOut({ global: true });
      window.location.href = 'https://relufox.ai';
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Layout>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        <h1>Account Management</h1>
        
        <div style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
            <div style={{ position: 'relative' }}>
              <button 
                onClick={() => setShowProductsDropdown(!showProductsDropdown)}
                style={{
                  background: '#1e3c72',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '1rem'
                }}
              >
                Products ▼
              </button>
              
              {showProductsDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  background: 'white',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  minWidth: '150px',
                  zIndex: 1000,
                  marginTop: '5px'
                }}>
                  <div style={{
                    padding: '12px 16px',
                    color: '#666',
                    fontSize: '14px'
                  }}>
                    No products available
                  </div>
                </div>
              )}
            </div>
            
            <button 
              onClick={handleHomeClick}
              style={{
                background: '#2a5298',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Home
            </button>
            
            <button 
              onClick={handleLogout}
              style={{
                background: '#f44336',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AccountManagement;